import React from "react";

export default function Digitalisierung() {
	return (
		<>
			<div className="beratung_cont" id="processmanagement">
				<h1>Beratung bei der Digitalisierung und Prozessmanagement</h1>
				<h2>
					Wir unterstützen Sie bei der optimalen Aufstellung Ihres Unternehmens
				</h2>
				<p>
					Die Feingeist Beratung unterstützt Sie bei der Strukturierung und
					Verbesserung Ihrer Prozesse und auf dem Weg in die Digitalisierung.
				</p>
				<h2>Ihre Vorteile:</h2>
				<ul className="typeset-u-list">
					<li>Modellierung und Optimierung von Prozesslandschaften</li>
					<li>
						Abgleich der IST-Situation mit Branchenstandards und aktuellen
						Entwicklungen
					</li>
					<li>Implementierung neuer Geschäftsprozesse zur Umsatzgenerierung</li>
					<li>
						Entwicklung und Implementierung individueller Soll-Bilder zur
						Steigerung der Effizienzen
					</li>
				</ul>
				<p>
					Die Feingeist Beratung fokussiert sich bei der Optimierung Ihrer
					Geschäftsprozesse darauf, wie die Bedürfnisse Ihrer Kunden — als
					Quelle Ihres Unternehmenserfolgs — bestmöglich zufriedengestellt
					werden können und anderseits auf die Erschließung neuer
					Umsatzmöglichkeiten bei gleichzeitiger Effizienzsteigerung in den
					vorhandenen Prozessen. Optimierungen im sog. Backoffice (also z.B. im
					Finanzbereich) werden dabei nicht außen vor gelassen.
				</p>
				<h2>Unser Ansatz zur Digitalisierung</h2>
				<p>
					Digitalisierung bezeichnet die Einbeziehung neuer Technologien in
					geschäftliche und soziale Prozesse mit dem Ziel, diese zu verbessern.
					Dabei wird zwischen der Art und Weise wie die Unternehmen intern und
					extern kommunizieren und der Art und Weise wie die Unternehmen die
					Leistung erbringen unterschieden.
				</p>
				<p>Zusammengefasst sollte dabei die</p>
				<ul className="typeset-u-list">
					<li>Zukunftssicherung des Geschäftsmodells,</li>
					<li>die Bewältigung neuer Herausforderungen sowie die</li>
					<li>Erschließung neuer Erlösquellen und Potentiale</li>
				</ul>
				<p>Ziel einer Digitalisierung sein.</p>
				<p>
					Eine ganzheitliche Aufnahme der IST-Situation der strategischen und
					digitalen Ausrichtung Ihrer Unternehmung ermöglicht die Feingeist
					Beratung durch eigene Tools.
				</p>
				<p>Sprechen Sie uns an.</p>
			</div>
		</>
	);
}
